/*
  Mirrors the Google review score into the buy box.

  The store's Reputon widget shows 4.8 from 266 reviews, but it sat at position 7
  of 8 on the product page - below two blocks that have now been hidden - so the
  strongest trust signal on the page was nowhere near the decision it should
  support. On a $3,000 considered purchase, "is this a real business" is the
  objection worth answering next to the price.

  The numbers are READ FROM THE RENDERED WIDGET rather than typed into the theme.
  That keeps one source of truth: when the score moves, this moves with it, and
  there is no hardcoded "4.8" to quietly go stale. If the widget does not load,
  or the app is removed, nothing renders - which is the correct failure, since
  inventing a rating would be worse than showing none.

  Clicking scrolls to the widget instead of leaving the page, so the proof is one
  tap away without losing the buy box.
*/
(function () {
  'use strict';

  var WIDGET = '.reputon-google-reviews-widget, [class*="reputon"]';

  function parseWidget() {
    var host = document.querySelector(WIDGET);
    if (!host) return null;

    var text = (host.innerText || '').replace(/\s+/g, ' ').trim();
    if (!text) return null;

    /* Reads like "CTX Home Gyms 4.8 266 reviews". Rating is the first decimal
       between 0 and 5; count is the number attached to the word "review". */
    var rating = text.match(/\b([0-5](?:\.\d)?)\b(?=\s*\d|\s*star|\s*out)/i);
    var count  = text.match(/([\d,]+)\s*(?:google\s*)?reviews?/i);

    if (!rating || !count) return null;

    var r = parseFloat(rating[1]);
    if (!(r > 0 && r <= 5)) return null;

    return { rating: rating[1], count: count[1], host: host };
  }

  function render(data) {
    /* Under the price rather than the title: the price is where the decision
       happens, and the title area is already carrying the ships-in badge. */
    var anchor = document.querySelector('.cp-price-row') ||
                 document.querySelector('#cp-price-sale') ||
                 document.querySelector('.cp-info .price');
    if (!anchor || document.querySelector('.cp-rating')) return;

    var a = document.createElement('a');
    a.className = 'cp-rating';
    a.href = '#ctx-reviews';
    a.setAttribute('aria-label',
      data.rating + ' out of 5 from ' + data.count + ' Google reviews. Read the reviews.');
    a.innerHTML =
      '<span class="cp-rating__stars" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor">' +
          '<path d="M12 17.3 6.2 20.6l1.6-6.6L2.6 9.6l6.7-.6L12 2.8l2.7 6.2 6.7.6-5.2 4.4 1.6 6.6z"/>' +
        '</svg>' +
      '</span>' +
      '<strong>' + data.rating + '</strong>' +
      '<span class="cp-rating__count">' + data.count + ' Google reviews</span>';

    a.addEventListener('click', function (e) {
      var target = document.querySelector(WIDGET);
      if (!target) return;                 // let the anchor do whatever it can
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    anchor.parentNode.insertBefore(a, anchor.nextSibling);
  }

  function attempt() {
    var data = parseWidget();
    if (!data) return false;
    render(data);
    return true;
  }

  function start() {
    if (attempt()) return;

    /* The widget is an app embed and arrives after the theme's own markup, so a
       single read on load usually finds an empty shell. Watch until it fills,
       then stop - an observer left running on the whole document would fire on
       every cart drawer re-render for the life of the page. */
    var stop = false;
    var obs = new MutationObserver(function () {
      if (stop) return;
      if (attempt()) { stop = true; obs.disconnect(); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { if (!stop) { stop = true; obs.disconnect(); } }, 15000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
